"use strict";

import { profileConstants } from "../_constants";

export const getProfileDetailsRequest = (payload) => {
  return {
    type: profileConstants.GET_PROFILE_DETAILS_REQUEST,
    payload,
  };
};

export const getProfileDetailsComplete = (payload) => {
  return {
    type: profileConstants.GET_PROFILE_DETAILS_COMPLETE,
    payload,
  };
};

export const getProfilDetailsError = (payload) => {
  return {
    type: profileConstants.UPDATE_DISPLAY_NAME_ERROR,
    payload,
  };
};

export const updateDisplayNameRequest = (payload) => {
  return {
    type: profileConstants.UPDATE_DISPLAY_NAME_REQUEST,
    payload,
  };
};

export const updateDisplayNameComplete = (payload) => {
  return {
    type: profileConstants.UPDATE_DISPLAY_NAME_COMPLETE,
    payload,
  };
};

export const updateDisplayNameError = (payload) => {
  return {
    type: profileConstants.UPDATE_DISPLAY_NAME_ERROR,
    payload,
  };
};

export const updateProfilePictureRequest = (payload) => {
  return {
    type: profileConstants.UPDATE_PROFILE_PICTURE_REQUEST,
    payload,
  };
};

export const updateProfilePictureComplete = (payload) => {
  return {
    type: profileConstants.UPDATE_PROFILE_PICTURE_COMPLETE,
    payload,
  };
};

export const updateProfilePictureError = (payload) => {
  return {
    type: profileConstants.UPDATE_PROFILE_PICTURE_ERROR,
    payload,
  };
};
